import PropTypes from 'prop-types';
import { Layout, Button } from 'antd';
import { useIntercom } from 'react-use-intercom';
import { SupportIcon } from 'components/Icons';
import images from 'constants/images';

import './ErrorFallbackUI.scss';

const { Content } = Layout;

const ErrorFallbackUI = ({ message }) => {
  const { show } = useIntercom();

  return (
    <Content className="error-fallback-ui">
      <div className="content-inner">
        <img
          className="error-image"
          width="540"
          height="385"
          src={images.INTERNAL_SERVER_ERROR_IMG}
          alt="Error"
        />
        <h1 className="error-title">
          You weren't <br />supposed to see this
        </h1>
        <p className="message">{message}</p>
        <Button
          className="large-btn primary-btn action-btn"
          onClick={show}
          icon={<SupportIcon className="support-icon" />}>
          <span>Talk to support</span>
        </Button>
      </div>
    </Content>
  );
};

ErrorFallbackUI.defaultProps = {
  message: (
    <span>
      It looks like something went wrong on this page. You can try reloading,{" "}
      or contact our support team for assistance.
    </span>
  ),
};

ErrorFallbackUI.propTypes = {
  message: PropTypes.instanceOf(Object),
};

export default ErrorFallbackUI;
